import React from 'react';
import { connect, useSelector } from 'react-redux';
// import { PurchasedTokensStyle as styles } from "../../purchaseHistory.tailwind";
import { fetchUserOrders } from '../../../../redux/slices/purchaseHistorySlice';
import PurchasedTokens from './PurchasedTokens';
import NoDataFound from '../../NoDataFound';
import BottomPagination from '../../../shared/Pagination/BottomPagination/BottomPagination';
import PurchasedTokenListingSkeleton from '../Skeletons/PurchasedTokenSkeleton/PurchasedTokenListingSkeleton';

const PurchaseTokenListingPage = ({ fetchUserPurchasedOrders, fromDate, toDate }) => {
  const { orders, ordersLoading } = useSelector(state => state.purchaseHistory);
  const { currentSeason } = useSelector((state) => state.seasons);

  const ordersToBeMapped = orders?.orders;
  const totalPages = orders?.pagePages || 1;

  const handleApiCall = async (value) => {
    // Fetch data for the current page whenever the page number changes
    const data = {
      page: value.toString(),
      seasonId: currentSeason?._id,
    }

    if(fromDate) {
      data.dateFromFilter = fromDate;
    }
    if(toDate) {
      data.dateToFilter = toDate;
    }
    
    const _response = await fetchUserPurchasedOrders(data);

    if (fetchUserOrders.fulfilled.match(_response)) {
        // Scroll Top
        window.scrollTo(0, 0);
    }
  }

  // Handle page change
  const handlePageChange = (event, value) => {
    event.preventDefault();
    handleApiCall(value);
  }

  if (ordersLoading) {
    return (
      <PurchasedTokenListingSkeleton count={1} />
    )
  }

  return (
    <>
      {(ordersToBeMapped?.length > 0) ? (
          <>
            {ordersToBeMapped.map((order) => (
              <PurchasedTokens key={order._id} order={order} ordersLoading={ordersLoading} />
            ))}

            {/* Bottom Navigation */}
            {(totalPages > 1) && (
              <BottomPagination
                totalPages={totalPages} // Total pages for pagination
                currentPage={orders?.pageNumber || 1}
                onPageChange={handlePageChange}
              />
            )}
          </>
        ) : (
          <NoDataFound isToken={true} />
      )}
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
    fetchUserPurchasedOrders: (data) => dispatch(fetchUserOrders(data)), // Dispatch action to fetch orders with pagination
});

export default connect(null, mapDispatchToProps)(PurchaseTokenListingPage);